import type { Enums } from "@msuite/utils/types";
import { enumeration, number, string, table } from "@rocicorp/zero";

export const vehicle = table("vehicles")
	.columns({
		id: string(),
		orgId: string().from("org_id"),
		licensePlate: string().from("license_plate"),
		type: enumeration<Enums<"vehicleType">>(),
		createdBy: string().from("created_by"),
		createdAt: number().from("created_at"),
	})
	.primaryKey("id");
